/*
 * @Author: dingguowei
 * @Date: 2023-05-18 11:26:03
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-05-29 16:12:28
 */
import request from '@/plugins/axios'
const base = '/'

export function getProvideDetail(params) {
  return request({
    url: base + 'api/jd/provide/lg/detail/get',
    method: 'get',
    params
  })
}


export function getProvideDaily(params) {
  return request({
    url: base + 'api/jd/provide/lg/daily/get',
    method: 'get',
    params
  })
}

export function getProvideOrder(params) {
  return request({
    url: base + 'api/jd/provide/lg/order/get',
    method: 'get',
    params
  })
}

export function downloadProvideOrder(params) {
  return request({
    url: base + 'api/jd/provide/lg/download',
    method: 'get',
    params
  })
}


export function downloadAllProvideOrder(params) {
  return request({
    url: base + 'api/jd/provide/lg/download/all',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
    params
  })
}